module.exports = __webpack_public_path__ + "static/img/8.402c7471.jpg";